module.exports = __webpack_public_path__ + "img/hiw-4.96150836.svg";